import clsx from 'clsx';
import { unknownFlagUrl } from '@/common/assets';
import { DEFAULT_TEAM_NAME } from '@/common/constants';
import type { BracketCardRowProps } from './BracketCard.types';

export function BracketCardRow(props: BracketCardRowProps) {
  const {
    teamName = DEFAULT_TEAM_NAME,
    imageSrc = unknownFlagUrl,
    lastMeetingGoals,
    finalGoals,
    penaltyGoals,
    isLoser,
    isTbdHidden,
  } = props;

  const textColorClass =
    isLoser || teamName === DEFAULT_TEAM_NAME
      ? 'text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark'
      : 'text-pmw-label-primary-light dark:text-pmw-label-primary-dark';

  function renderCurrentScore() {
    if (finalGoals === undefined) {
      return <span className="font-robotoMedium text-[14px] leading-[20px]">-</span>;
    }

    return (
      <>
        <span className="font-robotoMedium text-[14px] leading-[20px]">{finalGoals}</span>
        {penaltyGoals !== undefined && (
          <span className="font-robotoMedium text-[14px] leading-[20px]">({penaltyGoals})</span>
        )}
      </>
    );
  }

  return (
    <div
      className={clsx(
        'flex gap-1 items-center',
        { invisible: teamName === DEFAULT_TEAM_NAME && isTbdHidden },
        textColorClass,
      )}
    >
      <img className="size-4" src={imageSrc} alt="" />
      <span className="mr-auto text-[14px] leading-[20px]">{teamName}</span>
      {lastMeetingGoals !== undefined && (
        <span className="font-roboto text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
          ({lastMeetingGoals})
        </span>
      )}
      {renderCurrentScore()}
    </div>
  );
}
